const { default: CommonServices } = require("./common/common");

class ChapterManagementService extends CommonServices {
  constructor() {
    // Keep the base at /topic since chapters are nested under topics
    super("/topics");
    this.subResource = "chapters";
  }

  // 1) GET topic/:topicId/chapters
  async getAllByTopic(topicId, params) {
    const nested = new CommonServices(`${this.url}/${topicId}/${this.subResource}`);
    return nested.getAll(params);
  }

  // 2) GET topic/:topicId/chapters/:chapterId
  async getByIdUnderTopic(topicId, chapterId) {
    const nested = new CommonServices(`${this.url}/${topicId}/${this.subResource}`);
    return nested.getById(chapterId);
  }

  // 3) PUT topic/:topicId/chapters/:chapterId
  async updateUnderTopic(topicId, chapterId, data) {
    const nested = new CommonServices(`${this.url}/${topicId}/${this.subResource}`);
    return nested.updateById(chapterId, data);
  }

  // 4) POST /topic/chapters
  async create(data) {
    const nested = new CommonServices(`${this.url}/${this.subResource}`);
    return nested.createOne(data);
  }

  // Optional: if your backend supports POST /topic/:topicId/chapters
//   async createUnderTopic(topicId, data) {
//     const nested = new CommonServices(`${this.url}/${topicId}/${this.subResource}`);
//     return nested.createOne(data);
//   }
}

const chapterManagementService = new ChapterManagementService();
export default chapterManagementService;